import { useState } from 'react'
import { Element } from '../../common/html/element'
import classes from './DropdownItem.module.scss'

export const DropdownItem = ({
  item,
  hideDropdown,
  handleChoose,
  noHiddenWhenClick,
}) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#F3F3F3')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={() => {
        handleChoose(item)
        !noHiddenWhenClick && hideDropdown(false)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ backgroundColor: bgColor }}
      className={classes.dropdownItem}
    >
      <div className={classes.item}>
        <Element
          elementName="p"
          style={{
            color: '#191D25',
            textTransform: 'uppercase',
          }}
        >
          {item?.organizationName}
        </Element>
      </div>
    </Element>
  )
}

DropdownItem.defaultProps = {
  isDetails: false,
}
